import { render, staticRenderFns } from "./uploadDX.vue?vue&type=template&id=6e82df61&"
import script from "./uploadDX.vue?vue&type=script&lang=js&"
export * from "./uploadDX.vue?vue&type=script&lang=js&"
import style0 from "./uploadDX.vue?vue&type=style&index=0&id=6e82df61&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports